import { getWhitepaperLandingPath } from '@/lib/whitepapers'
import { Link } from 'react-router-dom'

const RESOURCES_WHITEPAPER_LINKS = [
  { slug: 'empathy-imperative-2026', label: 'The Empathy Imperative' },
  { slug: 'great-recomposition-2026', label: 'The Great Recomposition' },
] as const

const linkClassName =
  'text-xs font-medium text-white tracking-[0.24px] hover:text-pelgo-blue-light transition-colors'
const columnHeadingClassName = 'text-base font-medium text-pelgo-blue-light tracking-[-0.32px]'

type SiteFooterProps = {
  /** Optional wrapper class (e.g. for animation). Footer outer element is always "bg-white w-full mt-auto p-4 md:p-8" unless overridden here. */
  className?: string
}

export function SiteFooter({ className = 'bg-white w-full mt-auto p-4 md:p-8' }: SiteFooterProps) {
  const currentYear = new Date().getFullYear()
  const scrollToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' })

  return (
    <footer className={className}>
      <div className="bg-pelgo-blue-dark text-white rounded-[32px] p-8 md:p-16">
        <div className="max-w-[1280px] mx-auto">
          <div className="flex flex-col md:flex-row justify-between items-start gap-8 md:gap-16 mb-8">
            <div className="shrink-0 flex flex-col gap-8">
              <div>
                <img src="/logo-white.png" alt="Pelgo" className="h-12 mb-8" />
              </div>
            </div>

            <div className="flex flex-wrap gap-8 md:gap-12">
              <div className="flex flex-col gap-4 min-w-[120px]">
                <p className={columnHeadingClassName}>Resources</p>
                <div className="flex flex-col gap-4">
                  <Link to="/resources/whitepapers" className={linkClassName} onClick={scrollToTop}>
                    All Whitepapers
                  </Link>
                  <Link
                    to="/severance-administration-playbook"
                    className={linkClassName}
                    onClick={scrollToTop}
                  >
                    Severance Administration Playbook
                  </Link>
                  <Link to="/#faq" className={linkClassName} onClick={scrollToTop}>
                    FAQ
                  </Link>
                  <Link to="/news" className={linkClassName} onClick={scrollToTop}>
                    News
                  </Link>
                  {RESOURCES_WHITEPAPER_LINKS.map(({ slug, label }) => (
                    <Link
                      key={slug}
                      to={getWhitepaperLandingPath(slug)}
                      className={linkClassName}
                      onClick={scrollToTop}
                    >
                      {label}
                    </Link>
                  ))}
                </div>
              </div>

              <div className="flex flex-col gap-4 min-w-[120px]">
                <p className={columnHeadingClassName}>Platform</p>
                <div className="flex flex-col gap-4">
                  <a
                    href="https://embrace.pelgo.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    className={linkClassName}
                  >
                    Embrace Login
                  </a>
                </div>
              </div>

              <div className="flex flex-col gap-4 min-w-[120px]">
                <p className={columnHeadingClassName}>Legal</p>
                <div className="flex flex-col gap-4">
                  <Link to="/terms-of-service" className={linkClassName} onClick={scrollToTop}>
                    Terms of Service
                  </Link>
                  <Link to="/privacy" className={linkClassName} onClick={scrollToTop}>
                    Privacy Policy
                  </Link>
                  <a
                    href="https://app.vanta.com/pelgo.com/trust/2vl9pvtk5h3ppc9dg6o4"
                    target="_blank"
                    rel="noopener noreferrer"
                    className={linkClassName}
                  >
                    Trust Center
                  </a>
                </div>
              </div>

              <div className="flex flex-col gap-4 min-w-[120px]">
                <p className={columnHeadingClassName}>Contact Us</p>
                <div className="flex flex-col gap-4">
                  <Link to="/contact" className={linkClassName} onClick={scrollToTop}>
                    Request Free Trial
                  </Link>
                  <a
                    href="https://www.linkedin.com/company/pelgo/about/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className={linkClassName}
                  >
                    LinkedIn
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 pt-8 border-t border-white/20">
            <p className="text-xs font-medium text-white tracking-[0.24px]">
              © {currentYear} Pelgo. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  )
}
